import * as svg from "../../../assets/upload-image.svg";

import {iconBuilder} from "./iconBuilder";

export const UploadImageIcon = iconBuilder(svg, "UploadImageIcon", "0 0 24 24");
